import {search as searchApi} from '../api/search';
import {transformSearchBucketContent} from '../utils/transformation';
import {updateContent} from './content';
import {
    GA_CHANGE_PAGE_ACTION,
    GA_SEARCH_CATEGORY,
    SEARCH_EVENT_NAVIGATION,
} from '../constants';
import * as analytics from '@eb/site-analytics';
// eslint-disable-next-line import/no-cycle
import {updateSearchLocation} from './location';
// eslint-disable-next-line import/no-cycle
import {updateSearchCriteria} from './search';
import {logDiscoveryRequest} from '../api/analytics';

const {trackEventFromState} = analytics;

export const RESET_PAGINATION = 'search/resetPagination';
export const resetPagination = () => ({
    type: RESET_PAGINATION,
});

export const SET_CURRENT_PAGE = 'search/setCurrentPage';
export const setCurrentPage = (futurePage) => ({
    type: SET_CURRENT_PAGE,
    payload: futurePage,
});

export const GET_FUTURE_PAGE = 'search/getFuturePage';
export const getFuturePage = () => ({
    type: GET_FUTURE_PAGE,
});

export const handleGetPage = (futurePage, history) => (
    (dispatch, getState) => {
        const state = getState();
        const {
            app: {
                guestId,
                publicId,
            },
            search: {
                eventSearch,
            },
            location: {
                slug,
            },
            pagination: {
                currentPage,
                event,
            },
        } = state;

        const nonZeroBasedFuturePage = futurePage + 1;

        const newEventSearch = {
            ...eventSearch,
            page: nonZeroBasedFuturePage,
        };

        const gaTrackingData = {
            category: GA_SEARCH_CATEGORY,
            label: `${currentPage}-${futurePage}`,
            action: GA_CHANGE_PAGE_ACTION,
        };

        const searchId = logDiscoveryRequest({
            eventSearch: newEventSearch,
            publicUserId: publicId,
            guestId,
            locationSlug: slug,
            userGenerated: true,
            navigation: SEARCH_EVENT_NAVIGATION,
            action: GA_CHANGE_PAGE_ACTION,
            // variant can be used to track experiments
            variant: null,
        });

        if (searchId) {
            gaTrackingData.dimensions = {
                searchId,
            };
        }


        trackEventFromState(state, gaTrackingData);

        /* If page already in state, return it */
        if (event[futurePage]) {
            dispatch(setCurrentPage(futurePage));
            dispatch(updateSearchCriteria(newEventSearch));
            return dispatch(updateSearchLocation(history));
        }

        /* Otherwise trigger loading state, and run search to fetch next page */
        dispatch(getFuturePage());

        return searchApi({searchQuery: newEventSearch})
            .then((response) => dispatch(updateContent(transformSearchBucketContent(response))))
            .then(() => dispatch(setCurrentPage(futurePage)))
            .then(() => dispatch(updateSearchLocation(history)));
    }
);
